import * as z from "../../../vendor/zod/src/index";
export default z.object({
    ok: z.boolean(),
    reason: z.string(),
});
